var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005B00",
    fillRule: "evenodd",
    d: "M19.192 6.153a.73.73 0 0 1 .148 1.052l-8.331 10.5a.8.8 0 0 1-.621.295.8.8 0 0 1-.621-.296L4.66 12.375a.73.73 0 0 1 .148-1.051.803.803 0 0 1 1.094.142l4.486 4.546 7.71-9.716a.803.803 0 0 1 1.094-.143",
    clipRule: "evenodd"
  })));
};
export default SvgSuccess;